import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME as name, CRUMB_LABEL_KEY, ZAKAZKAPP_CAMPAIGN, DEPENDENT_TABLES_ALL as depTableNames } from '../constants';
import { ZAKAZKA_DRUH } from '../../constants';
import { apiProvider } from '../api';
import { editActions, editMutations } from './types';

const dropdownList = {
	ProvozovnaId: [],
	VyrobekvozOzn: [],
	ZarmobilPzn: [],
	DphSzbOzn: [],
	LakdruhId: [],
	SplitParty: [],
	SplitBy: [],
	LineItemStatuses: [],
	StatusPendingReasons: [],
	ServiceJobForItems: [],
};

const edit = {
	CasJdnPoc: null as number | null,
	ServicePackageId: null as number | null,
	DphSzbOzn: null as number | null,
	DphSzbOznEnabled: null as boolean | null,
	EditDat: null as string | null,
	EditPracId: null as number | null,
	EditPracIdText: null as string | null,
	EditPrp: null as number | null,
	ElsaStatus: null as number | null,
	EmisePzn: null as number | null,
	HodSzb: null as number | null,
	HodSzbGar: null as number | null,
	HodSzbHruba: null as number | null,
	HodSzbInt: null as number | null,
	KalkulaceppId: null as number | null,
	LakJdnPoc: null as number | null,
	LakSzbGar: null as number | null,
	LakSzbHruba: null as number | null,
	LakSzbInt: null as number | null,
	LakSzbZak: null as number | null,
	LakdruhId: null as number | null,
	PcPevna: null as number | null,
	PcSpec: null as number | null,
	PneuskladppId: null as number | null,
	Poznamka2Dd: null as string | null,
	PpId: null as number | null,
	PpNr: null as string | null,
	PracovnikId: null as number | null,
	PracovnikIdText: null as string | null,
	PracovnikOsobniCis: null as string | null,
	ProvozovnaId: null as number | null,
	Sleva: null as number | null,
	SnId: null as number | null,
	StrednaklOzn: null as number | null,
	StrednaklOznText: null as string | null,
	StrnakltypOzn: null as number | null,
	StrnakltypOznOrig: null as number | null,
	Tablpozice: null as string | null,
	TablpoziceText: null as string | null,
	Text: null as string | null,
	TextEnabled: null as boolean | null,
	VstupDat: null as string | null,
	VstupPracId: null as number | null,
	VstupPracIdText: null as string | null,
	VstupProvId: null as number | null,
	VyrobekvozOzn: null as string | null,
	ZakazkaId: null as number | null,
	ZarmobilPzn: null as number | null,
	LineItemStatusId: null as number | null,
	LineItemStatusPendingReasonId: null as number | null,
	LineItemStatusPendingRemarksOthers: null as string | null,
	ActivityStartTime: null as string | null,
	ActivityEndTime: null as string | null,
	IsEligibleForCompletion: null as boolean | null,
	LakdruhPrp: null as boolean | null,
	PpTzPriv: null as boolean | null,
	IsKoncernoveVozidlo: null as boolean | null,
	FlagZmenaPcFix: null as boolean | null,
	FlagZmenaPcSpec: null as boolean | null,
	FlagZmenaSlevaZvlastni: null as boolean | null,
	DiscountVal: null as number | null,
	ZakazkaStav: null as number | null,
	ZakazkaDruh: null as ZAKAZKA_DRUH | null,
	ZakazkaSaga2: null as boolean | null,
	UpravaS2: null as boolean | null,
	NavrhPolId: null as number | null,
	ZakazkaVyrobekvozOzn: null as string | null,
	ZakazkaVozidloTablpozice: null as string | null,
	ZakazkaPracovnikId: null as number | null, // v dms to je Pracovnik_id_priv
	ZakazkaVozidloId: null as number | null,
	ZakazkaVozidloTypkod: null as string | null,
	ZakazkaVozidloKaroserieNr: null as string | null,

	SdaPp: null as boolean | null,
	SdaPpEnabled: null as boolean | null,
	SnPp: null as boolean | null,
	SnPpEnabled: null as boolean | null,
	IsAdditionalEnabled: null as boolean | null,
	TzPp: null as boolean | null,
	TzPpEnabled: null as boolean | null,
	PpNekonPrp: null as boolean | null,

	RozpracovanostEnabled: null as boolean | null,
	PpCheckEnabled: null as boolean | null,
	SplitParty: [] as number[],
	SplitBy: null as number | null,
	ShareValue: null as number | null,
	PojistovnaId: null as number | null,
	IsAdditional: null as boolean | null,
	AdditionalJobStatus: null as boolean | null,

	CustomerShareValue: null as number | null,
	InsuranceShareValue: null as number | null,
	GoodwillShareValue: null as number | null,
	OrderSubtypeId: 0 as number,
	LaborPrice: null as number | null,
	UnitPrice: null as number | null,
	ServiceJobId: null as number | null,
	Note: null as string | null,
	SagaItemStatus: null as number | null
};

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList,
	edit,
	depTableNames,
	depTableSettings: {
		[ZAKAZKAPP_CAMPAIGN]: {
			filter(state) {
				return {
					ZAKAZKAND_PKID: state.edit.PpId,
				};
			},
		},
	},
	localState: {
		selectedPracovniPozice: false,
	},
	extraActions: {
		async [editActions.NAKLADOVE_STREDISKO_MAPPER]({ commit }, { data }) {
			const dataForMutation: any = {
				StrednaklOzn: data.value,
				StrednaklOznText: data.text,
				StrnakltypOzn: data.strnakltypOzn,
			};
			if (!data.isClear) {
				dataForMutation.ProvozovnaId = data.provozovnaId;
			}
			commit(editMutations.NAKLADOVE_STREDISKO_MAPPER, { data: dataForMutation });
		},
		[editActions.LABOR_PRICE_MAPPER]: async ({ state }) => {
			if (state.edit.CasJdnPoc! > 0) {
				const { data: dataForPrice } = await apiProvider.getLaborPriceDetails(state.edit.ZakazkaId!, state.edit.PpNr!,null, null);
				state.edit.LaborPrice = dataForPrice;
				state.edit.UnitPrice = dataForPrice;
			}
		},
	},
	extraGetters: {},
	extraMutations: {
		[editMutations.UNSET_PPNR](state) {
			state.edit.CasJdnPoc = null;
			state.edit.LakJdnPoc = null;
			state.localState.selectedPracovniPozice = false;
		},
		[editMutations.PRACOVNI_POZICE_PPNR_SELECT_MAPPER](state, { data }) {
			state.edit.PpNr = data.ppNr ? data.ppNr.trim() : null;
			state.edit.Text = data.popis ? data.popis : null;
			state.edit.CasJdnPoc = data.casJdnPoc ?? null;
			state.edit.LakJdnPoc = data.lakJdnPoc ?? 0;
			state.edit.EditPrp = data.editPrp;
			state.localState.selectedPracovniPozice = data.selectComplete ?? false;
			state.edit.PcPevna = data.pcPevna;
			state.edit.PcSpec = data.pcSpec;
		},
		[editMutations.PRACOVNI_POZICE_TABLPOZ_SELECT_MAPPER](state, { data }) {
			state.edit.Tablpozice = data.value;
			state.edit.TablpoziceText = data.text;
		},
		[editMutations.PRACOVNIK_SELECT_MAPPER](state, { data }) {
			state.edit.PracovnikId = data.value;
			state.edit.PracovnikIdText = data.jmeno || data.text ? `${data.text} ${data.jmeno}` : null;
			state.edit.PracovnikOsobniCis = data.osobniCis;
			if (data.value) {
				state.edit.ProvozovnaId = data.provozovnaId;
				state.edit.StrednaklOzn = data.strednaklOzn;
				state.edit.StrednaklOznText = data.strednaklOznText;
				state.edit.StrnakltypOzn = data.strnakltypOzn;
			}
		},
		[editMutations.NAKLADOVE_STREDISKO_MAPPER](state, { data }) {
			state.edit.StrednaklOzn = data.StrednaklOzn;
			state.edit.StrednaklOznText = data.StrednaklOznText;
			state.edit.StrnakltypOzn = data.StrnakltypOzn;
			if (data.ProvozovnaId) {
				state.edit.ProvozovnaId = data.ProvozovnaId;
			}
		},
	},
	props: {
		mode: null,
		mnozstvi: null as number | null,
		saga2Status: null as number | null,
		zarmobilPzn: null as number | null,
		strnakltypOzn: null as number | null,
		polozkaText: null as string | null,
		polozkaNr: null as string | null,
		pcPevna: null as number | null,
		lakJdnPoc: null as number | null,
		emisePzn: null as number | null,
		dphSzbOzn: null as number | null,
		cinnostPrp: null as number | null,
		casJdnPoc: null as number | null,
		polozkaId: null as number | null,
		filter: {
			KaroserieNr: null as number | null,
		},
	},
});
